export enum SsoType {
  SAML = 'saml',
  SAML_SSK = 'split_saml',
  OAUTH = 'oauth',
  OIDC_SSK = 'split_oidc',
}
